import * as React from 'react';
import { memo } from 'react';

import type { CmlContent } from '__generated__/graphql-types-do-not-use';

import { CML } from 'bundles/cml';
import convertToCmlContent from 'bundles/unified-description-page-common/utils/convertToCmlContent';

type Props = {
  cml: CmlContent;
};

const CMLWrapper = ({ cml }: Props) => {
  return (
    <CML
      cml={convertToCmlContent(cml)}
      shouldRenderMath={false}
      shouldRenderCode={false}
      shouldRenderAssets={false}
      isCdsEnabled
      className="unified-CML"
    />
  );
};

export default memo(CMLWrapper);
